import Blue from "~/core";

new Blue({
  name: 'Header Nav Menu',
  selector: '.header',
  setup(header) {
    const inner = header.querySelector('.header__inner');
    const utilItems = [...header.querySelectorAll('.header__util-item')];
    const navItems = [...header.querySelectorAll('.header__nav-item')];
    const navSubItems = [...header.querySelectorAll('.header__nav-group')];

    const media = this.$screen.lg;
    const mediaDown = this.$screen.lg_dn;

    const drawerToggle = header.querySelector('.header__toggle');
    const drawer = header.querySelector('.header__drawer');
    if(!drawer)
      return;

    const drawerList = drawer.querySelector('.header__drawer-list');

    function updateHeaderHeightVar() {
      const header = document.querySelector("header.sticky");
      if (header) {
        const height = header.offsetHeight;
        document.documentElement.style.setProperty('--header-height', `${height}px`);
      }
    }
    
    window.addEventListener('load', updateHeaderHeightVar);
    window.addEventListener('resize', updateHeaderHeightVar);
    
    const toggleMenu = (item, close = false) => {
      const subMenu = item.querySelector(
        '.header__nav-menu, .header__nav-group-list'
      );
      const parentMenu = item.querySelector(
        '.header__nav-menu, .header__nav-group-list'
      );
      if (subMenu) subMenu.scrollTo(0, 0);
      if (parentMenu) parentMenu.scrollTo(0, 0);
      drawerList.scrollTo(0, 0);
      item.classList[close ? 'remove' : 'toggle']('is-active');
    };

    const toggleDrawer = (close = false) => {
      const alert = header.querySelector('.alert');
      const alertHeight = alert ? alert.offsetHeight : 0;
      const innerStyles = getComputedStyle(inner);
      const topPadding = parseInt(innerStyles.getPropertyValue('padding-top'));
      const gridRow = parseInt(
        innerStyles.getPropertyValue('grid-template-rows').split(' ')[0]
      );
      const gap = parseInt(innerStyles.getPropertyValue('row-gap') || 0);
      const offset = alertHeight + topPadding + gridRow + gap - 1;
      drawer.style.top = `${offset}px`;

      header.classList[close ? 'remove' : 'toggle']('is-open');

      if (header.classList.contains('is-open')) {
        drawerToggle.classList.add('is-open');
        drawer.classList.add('is-open');
      } else {
        drawerToggle.classList.remove('is-open');
        drawer.classList.remove('is-open');
      }
      closeAllActive({});
    };

    const closeAllActive = e => {
      const target = e.target;
      const active = [...header.querySelectorAll('.is-active')];
      active.forEach(item => {
        if (!target || target === window) toggleMenu(item, true);
        else {
          if (!item.contains(target)) toggleMenu(item, true);
        }
      });
    };

    const bindUtilEvents = item => {
      const trigger = item.querySelector('button.header__util-label');
      const back = item.querySelector('button.header__nav-back');

      if (!trigger) return;
      this.$addEvents(trigger, 'click.prevent enter.prevent', () => {
        toggleMenu(item);
      });
      if (back) {
        this.$addEvents(back, 'click.prevent enter.prevent', () => {
          toggleMenu(item, true);
        });
      }
    };

    const adjustDesktopMenuPosition = (item, menu) => {
      if (item.classList.contains('is-active')) return;
      menu.style.left = '';
      const windowWidth = window.innerWidth;
      const menuWidth = menu.offsetWidth;
      const menuLeft = menu.getBoundingClientRect().left;

      if (media.matches && windowWidth < menuWidth + menuLeft) {
        const adjust = menuWidth + menuLeft - windowWidth;
        menu.style.left = `calc(50% - ${adjust}px)`;
      }
    };

    const bindNavEvents = item => {
      const trigger = item.querySelector('button.header__nav-label');
      const menu = item.querySelector('.header__nav-menu');
      const back = item.querySelector('button.header__nav-back');
      let grid;

      if (trigger) {
        if (item.classList.contains('header__nav-item--full')) {
          grid = item.querySelector('.header__nav-grid');
        }
        this.$addEvents(trigger, 'click.prevent enter.prevent', () => {
          if (menu) adjustDesktopMenuPosition(item, menu);
          toggleMenu(item);
          if (grid) resizeAllGridItems(grid);
        });
      }
      if (back) {
        const viewAll = back.querySelector('a');
        if (viewAll) {
          this.$addEvents(viewAll, 'click.stop enter.stop', () => false);
        }
        this.$addEvents(back, 'click.prevent enter.prevent', () => {
          toggleMenu(item, true);
        });
      }
    };

    const bindSubNavEvents = item => {
      const trigger = item.querySelector('.header__nav-group-title');
      const back = item.querySelector('.header__nav-back');
      if (trigger) {
        this.$addEvents(trigger, 'click enter', e => {
          if (mediaDown.matches) {
            e.preventDefault();
            toggleMenu(item);
          }
        });
      }
      if (back) {
        const viewAll = back.querySelector('a');
        if (viewAll) {
          this.$addEvents(viewAll, 'click.stop enter.stop', () => false);
        }
        this.$addEvents(back, 'click.prevent enter.prevent', () => {
          toggleMenu(item, true);
        });
      }
    };

    const bindDrawerEvents = () => {
      const filteredUtilItems = utilItems.filter(
        i => !i.classList.contains('header__util-item--persist')
      );
      this.$addEvents(drawerToggle, 'click.prevent enter.prevent', () =>
        toggleDrawer()
      );
      this.$retach(navItems, {
        destination: drawerList,
        mediaQuery: mediaDown,
        movedClass: 'header__drawer-item',
      });
    };


    const initialize = () => {
      utilItems.forEach(bindUtilEvents);
      navItems.forEach(bindNavEvents);
      navSubItems.forEach(bindSubNavEvents);
      bindDrawerEvents();
      this.$addEvents(document, 'click.stop, enter.stop', e => {
        closeAllActive(e);
      });
      window.addEventListener('resize', e => {
        if (media.matches) closeAllActive(e);
        toggleDrawer(true);
      });
    };

    initialize();

    function resizeGridItem(grid, item) {
      const gridStyles = getComputedStyle(grid);
      const content = item.querySelector('.header__nav-grid-content');
      const contentRect = content.getBoundingClientRect();
      const rowHeight =
        parseInt(gridStyles.getPropertyValue('grid-auto-rows')) || 10;
      const rowGap = parseInt(gridStyles.getPropertyValue('grid-row-gap')) || 0;
      const rowSpan = Math.ceil((contentRect.height + rowGap) / (rowHeight + rowGap)) + 1;
      item.style.gridRowEnd = `span ${rowSpan}`;
    }

    function resizeAllGridItems(grid) {
      const items = [...grid.querySelectorAll('.header__nav-grid-cell')];
      items.forEach(item => (item.style.gridRowEnd = ''));
      items.forEach(item => resizeGridItem(grid, item));
      items.forEach(item => labelItemsInLastColumn(grid, item));
    }

    function labelItemsInLastColumn(grid, item) {
      const gridStyles = getComputedStyle(grid);
      const columnWidths = gridStyles
        .getPropertyValue('grid-template-columns')
        .split(' ')
        .map(w => parseFloat(w));
      const totalColumns = columnWidths.length;
      const gapWidth = parseInt(gridStyles.getPropertyValue('column-gap') || 0);
      const gridInternalWidth = Math.floor(
        [
          ...columnWidths,
          ...Array(columnWidths.length - 1).fill(gapWidth),
        ].reduce((sum, item) => (sum += item), 0)
      );
      const gridInternalLeftOffset = Math.floor(
        (grid.offsetWidth - gridInternalWidth) / 2
      );
      const itemLeft = item.offsetLeft;

      let offsetCheck = gridInternalLeftOffset;
      let column = 0;

      columnWidths.some(columnWidth => {
        let currentCheck = offsetCheck;
        offsetCheck = Math.round(offsetCheck + columnWidth + gapWidth);
        column = column + 1;
        if (itemLeft <= currentCheck + 1 && itemLeft >= currentCheck - 1) {
          return true;
        }
        return false;
      });
      if (column === totalColumns) item.classList.add('is-last-column');
      else item.classList.remove('is-last-column');
    }
  },
});
